import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'appointment-expiration-select',
	templateUrl: './appointment-expiration-select.component.html',
	styleUrls: ['./appointment-expiration-select.component.scss'],
})
export class AppointmentExpirationSelectComponent implements OnInit {
	@Input() formGroup: FormGroup;
	@Input() isUserPremium;
	@Output() onChange = new EventEmitter();
	options = [];
	constructor(public translateService: TranslateService) {}

	ngOnInit(): void {
		this.setOptions();
	}

	setOptions() {
		this.options = [
			{
				label: this.translateService.instant(
					'SCHEDULE.EXPIRATION_OPTIONS.NO_EXPIRATION'
				),
				value: null,
			},
			{
				label: this.translateService.instant(
					'SCHEDULE.EXPIRATION_OPTIONS.12_HOURS_BEFORE'
				),
				value: 720,
			},
			{
				label: this.translateService.instant(
					'SCHEDULE.EXPIRATION_OPTIONS.24_HOURS_BEFORE'
				),
				value: 1440,
			},
			{
				label: this.translateService.instant(
					'SCHEDULE.EXPIRATION_OPTIONS.48_HOURS_BEFORE'
				),
				value: 2880,
			},
		];
	}
}
